
const errorPageStyles = () => ({
  contentCenter: {
    position: "absolute",
    top: "50%",
    left: "50%",
    zIndex: "3",
    transform: "translate(-50%,-50%)",
    textAlign: "center",
    color: "#FFFFF",
    padding: "0 15px",
    width: "100%",
    maxWidth: "880px",
  },
  title: {
    fontSize: "8em",
    color: "#FFFF",
    letterSpacing: "14px",
    fontWeight: "700",
  },
  subTitle: {
    fontSize: "2.25rem",
    marginTop: "0",
    marginBottom: "8px",
    color:"#ffff"
  },
  description: {
    fontSize: "1.125rem",
    marginTop: "0",
    marginBottom: "8px",
    color:"#ffff"
  },
});

export default errorPageStyles;
